import _ from "lodash";

export const getRoundOffAmount = (value: number, decimalPlaces: number) => {
  return Number(_.round(value, decimalPlaces));
};
